import * as React from 'react';
import { Route, Routes } from 'react-router-dom';
import { InstitutionProposalAction } from './InstitutionProposalAction';
import { InstitutionProposalDisplay } from './InstitutionProposalDisplay';
import { InstitutionProposalSearch } from './InstitutionProposalSearch';
import { Four04 } from 'gossamer-front-end';

export const InstitutionProposalRoutes = (): React.JSX.Element => (
  <Routes>
    <Route path="/action/:key" element={<InstitutionProposalAction />} />
    <Route path="/display/:key" element={<InstitutionProposalDisplay />} />
    <Route path="/search" element={<InstitutionProposalSearch />} />
    <Route path="*" element={<Four04 />} />
  </Routes>
);
